import React, { useState } from "react";
import { IPlayer, ITellInput, Storage } from "./storage";

export function Poker() {
  const [players] = useState<IPlayer[]>(Storage.getPlayers());
  const [tells] = useState<ITellInput[]>(Storage.getTells());
  const [selectedPlayerId, setSelectedPlayerId] = useState<string | null>(null);

  const filteredTells = selectedPlayerId
    ? tells.filter((tell) => tell.playerId === selectedPlayerId)
    : tells;

  return (
    <div>
      <h1>Tells</h1>

      <div>
        <h2>Filter by Player</h2>
        <select
          value={selectedPlayerId || ""}
          onChange={(e) => setSelectedPlayerId(e.target.value)}
        >
          <option value="">All Players</option>
          {players.map((player) => (
            <option key={player.id} value={player.id}>
              {player.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <h2>Tell List</h2>
        {filteredTells.length > 0 ? (
          <ul>
            {filteredTells.map((tell, index) => (
              <li key={index}>
                <p>
                  <strong>Player:</strong>{" "}
                  {players.find((player) => player.id === tell.playerId)?.name}
                </p>
                <p>
                  <strong>Behaviors:</strong>{" "}
                  {tell.behaviorIds
                    .map((id) =>
                      Storage.getBehaviors().find((behavior) => behavior.id === id)?.name
                    )
                    .join(", ")}
                </p>
                <p>
                  <strong>Results:</strong>{" "}
                  {tell.results
                    .map((id) =>
                      Storage.getResults().find((result) => result.id === id)?.name
                    )
                    .join(", ")}
                </p>
                <p>
                  <strong>Comment:</strong> {tell.comment}
                </p>
                <p>
                  <strong>Created At:</strong> {new Date(tell.createdAt).toLocaleString()}
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No tells found.</p>
        )}
      </div>
    </div>
  );
}
